import React from 'react'
import classNames from 'classnames/bind'

export const CX = classNames.bind(_s)

export const APP_NAME = 'Gab Social'

export const COLOR_BRAND = '#0e8345'
export const AVAILABLE_ACCENT_COLORS = ['#e8546a', '#d65db0', '#9b6bdb', '#4361ee', '#2196f3', '#00bcd4', '#1aae9f', '#0e8345', '#d49516', '#e07838', '#6f7b88', '#8b7d70']
export const AVAILABLE_ACCENT_COLORS_VALUES = {
  '#e8546a': {
    'highlight': '#FCDDE1',
    'dark': '#C0404F',
    'light': '#EE8290',
    'light_opaque': 'rgba(232, 84, 106, 0.175)'
  },
  '#d65db0': {
    'highlight': '#F8DAF0',
    'dark': '#B04590',
    'light': '#E285C4',
    'light_opaque': 'rgba(214, 93, 176, 0.175)'
  },
  '#9b6bdb': {
    'highlight': '#E8DBF7',
    'dark': '#7B50B5',
    'light': '#B590E5',
    'light_opaque': 'rgba(155, 107, 219, 0.175)'
  },
  '#4361ee': {
    'highlight': '#D4DDFB',
    'dark': '#3450C4',
    'light': '#7590F3',
    'light_opaque': 'rgba(67, 97, 238, 0.175)'
  },
  '#2196f3': {
    'highlight': '#8CCAFF',
    'dark': '#0069C0',
    'light': '#6EC6FF',
    'light_opaque': 'rgba(33, 150, 243, 0.175)'
  },
  '#00bcd4': {
    'highlight': '#80DEEA',
    'dark': '#00838F',
    'light': '#4DD0E1',
    'light_opaque': 'rgba(0, 188, 212, 0.175)'
  },
  '#1aae9f': {
    'highlight': '#C6F0EC',
    'dark': '#158C80',
    'light': '#50C2B6',
    'light_opaque': 'rgba(26, 174, 159, 0.175)'
  },
  '#0e8345': {
    'highlight': '#C5E8D5',
    'dark': '#0A6835',
    'light': '#45A06E',
    'light_opaque': 'rgba(14, 131, 69, 0.175)'
  },
  '#d49516': {
    'highlight': '#F6E6C4',
    'dark': '#A87510',
    'light': '#E0B04E',
    'light_opaque': 'rgba(212, 149, 22, 0.175)'
  },
  '#e07838': {
    'highlight': '#F9E0CF',
    'dark': '#B85E28',
    'light': '#E89A68',
    'light_opaque': 'rgba(224, 120, 56, 0.175)'
  },
  '#6f7b88': {
    'highlight': '#DEE2E7',
    'dark': '#58626D',
    'light': '#939DA8',
    'light_opaque': 'rgba(111, 123, 136, 0.175)'
  },
  '#8b7d70': {
    'highlight': '#E6E1DC',
    'dark': '#6F6459',
    'light': '#A89D92',
    'light_opaque': 'rgba(139, 125, 112, 0.175)'
  }
}



export const DEFAULT_REL = 'noopener'

export const BREAKPOINT_EXTRA_LARGE = 8480
export const BREAKPOINT_LARGE = 992
export const BREAKPOINT_MEDIUM = 992
export const BREAKPOINT_SMALL = 992
export const BREAKPOINT_EXTRA_SMALL = 992
/** Viewport width above which the right sidebar (trends, ads, etc.) is shown. Below this, center feed has more room. */
export const BREAKPOINT_RIGHT_SIDEBAR = 1280

export const MEDIA_SINGLE_MAX_HEIGHT = 450

export const MOUSE_IDLE_DELAY = 300

export const MIN_UNAUTHENTICATED_PAGES = 1

export const LAZY_LOAD_SCROLL_OFFSET = 50

export const MAX_POLL_OPTOINS = 8

export const REACTIONS_INITIATOR_DELAY = 850

export const ALLOWED_AROUND_SHORT_CODE = '><\u0085\u0020\u00a0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\u0009\u000a\u000b\u000c\u000d'
export const MAX_PRO_POST_CHARACTER_COUNT = 15000
export const MAX_FREE_POST_CHARACTER_COUNT = 5000

export const URL_DISSENTER_SHOP = 'https://shop.dissenter.com'
export const URL_DISSENTER_SHOP_DONATIONS = 'https://shop.dissenter.com/category/donations'
export const URL_GAB_PRO = 'https://pro.gab.com'
export const URL_INVEST_2023 = 'https://vccross.com/project/invest-in-gab'

export const PLACEHOLDER_MISSING_HEADER_SRC = '/original/missing.png'
export const PLACEHOLDER_MISSING_BIZ_HEADER_SRC = '/original/missing.png'

export const POPOVER_BUSINESS_OPTIONS = 'BUSINESS_OPTIONS'
export const POPOVER_CHAT_CONVERSATION_OPTIONS = 'CHAT_CONVERSATION_OPTIONS'
export const POPOVER_CHAT_MESSAGE_OPTIONS = 'CHAT_MESSAGE_OPTIONS'
export const POPOVER_CHAT_CONVERSATION_EXPIRATION_OPTIONS = 'CHAT_CONVERSATION_EXPIRATION_OPTIONS'
export const POPOVER_CHAT_SETTINGS = 'CHAT_SETTINGS'
export const POPOVER_COMMENT_SORTING_OPTIONS = 'COMMENT_SORTING_OPTIONS'
export const POPOVER_COMPOSE_MEDIA_DESCRIPTION = 'COMPOSE_MEDIA_DESCRIPTION'
export const POPOVER_COMPOSE_POST_CONTEXT = 'COMPOSE_POST_CONTEXT'
export const POPOVER_REPLY_GROUP = 'REPLY_GROUP'
export const POPOVER_COMPOSE_POST_DESTINATION = 'COMPOSE_POST_DESTINATION'
export const POPOVER_DATE_PICKER = 'DATE_PICKER'
export const POPOVER_EMOJI_PICKER = 'EMOJI_PICKER'
export const POPOVER_GROUP_LIST_SORT_OPTIONS = 'GROUP_LIST_SORT_OPTIONS'
export const POPOVER_GROUP_MEMBER_OPTIONS = 'GROUP_MEMBER_OPTIONS'
export const POPOVER_GROUP_OPTIONS = 'GROUP_OPTIONS'
export const POPOVER_GROUP_TIMELINE_SORT_OPTIONS = 'GROUP_TIMELINE_SORT_OPTIONS'
export const POPOVER_GROUP_TIMELINE_SORT_TOP_OPTIONS = 'GROUP_TIMELINE_SORT_TOP_OPTIONS'
export const POPOVER_EXPLORE_TIMELINE_SORT_OPTIONS = 'POPOVER_EXPLORE_TIMELINE_SORT_OPTIONS'
export const POPOVER_EXPLORE_TIMELINE_SORT_TOP_OPTIONS = 'POPOVER_EXPLORE_TIMELINE_SORT_TOP_OPTIONS'
export const POPOVER_HOME_TIMELINE_SORT_OPTIONS = 'HOME_TIMELINE_SORT_OPTIONS'
export const POPOVER_LISTS_SORT_OPTIONS = 'LISTS_SORT_OPTIONS'
export const POPOVER_MANAGED_BUSINESSES = 'MANAGED_BUSINESSES'
export const POPOVER_MARKETPLACE_LISTING_CHANGE_STATUS = 'MARKETPLACE_LISTING_CHANGE_STATUS'
export const POPOVER_MARKETPLACE_LISTING_DASHBOARD_STATUS_OPTIONS = 'MARKETPLACE_LISTING_DASHBOARD_STATUS_OPTIONS'
export const POPOVER_MARKETPLACE_LISTING_OPTIONS = 'MARKETPLACE_LISTING_OPTIONS'
export const POPOVER_NAV_SETTINGS = 'NAV_SETTINGS'
export const POPOVER_NOTIFICATION_SETTINGS = 'NOTIFICATION_SETTINGS'
export const POPOVER_PROFILE_OPTIONS = 'PROFILE_OPTIONS'
export const POPOVER_SIDEBAR_MORE = 'SIDEBAR_MORE'
export const POPOVER_STATUS_OPTIONS = 'STATUS_OPTIONS'
export const POPOVER_STATUS_MODAL_CONFIRM = 'STATUS_MODAL_CONFIRM'
export const POPOVER_STATUS_EXPIRATION_OPTIONS = 'STATUS_EXPIRATION_OPTIONS'
export const POPOVER_SHARE = 'POPOVER_SHARE'
export const POPOVER_SHORTCUTS = 'POPOVER_SHORTCUTS'
export const POPOVER_STATUS_REACTIONS_COUNT = 'STATUS_REACTIONS_COUNT'
export const POPOVER_STATUS_REACTIONS_SELECTOR = 'STATUS_REACTIONS_SELECTOR'
export const POPOVER_STATUS_VISIBILITY = 'STATUS_VISIBILITY'
export const POPOVER_TIMELINE_INJECTION_OPTIONS = 'TIMELINE_INJECTION_OPTIONS'
export const POPOVER_USER_INFO = 'USER_INFO'

export const MODAL_BLOCK_ACCOUNT = 'BLOCK_ACCOUNT'
export const MODAL_BOOKMARK_COLLECTION_CREATE = 'BOOKMARK_COLLECTION_CREATE'
export const MODAL_BOOKMARK_COLLECTION_EDIT = 'BOOKMARK_COLLECTION_EDIT'
export const MODAL_BOOST = 'BOOST'
export const MODAL_BUSINESS_CATEGORIES = 'MODAL_BUSINESS_CATEGORIES'
export const MODAL_CHAT_CONVERSATION_CREATE = 'CHAT_CONVERSATION_CREATE'
export const MODAL_CHAT_CONVERSATION_DELETE = 'CHAT_CONVERSATION_DELETE'
export const MODAL_CHAT_CONVERSATION_MEMBERS = 'CHAT_CONVERSATION_MEMBERS'
export const MODAL_CHAT_CONVERSATION_OPTIONS = 'CHAT_CONVERSATION_OPTIONS'
export const MODAL_COMPOSE = 'COMPOSE'
export const MODAL_CONFIRM = 'CONFIRM'
export const MODAL_COUPONS = 'MODAL_COUPONS'
export const MODAL_DECK_COLUMN_ADD = 'DECK_COLUMN_ADD'
export const MODAL_DECK_COLUMN_ADD_OPTIONS = 'DECK_COLUMN_ADD_OPTIONS'
export const MODAL_DISPLAY_OPTIONS = 'DISPLAY_OPTIONS'
export const MODAL_DONATE = 'DONATE'
export const MODAL_EDIT_PROFILE = 'EDIT_PROFILE'
export const MODAL_EDIT_SHORTCUTS = 'EDIT_SHORTCUTS'
export const MODAL_EMAIL_CONFIRMATION_REMINDER = 'EMAIL_CONFIRMATION_REMINDER'
export const MODAL_GIFT_GAB_PRO = 'GIFT_GAB_PRO'
export const MODAL_GROUP_CREATE = 'GROUP_CREATE'
export const MODAL_GROUP_DELETE = 'GROUP_DELETE'
export const MODAL_GROUP_PASSWORD = 'GROUP_PASSWORD'
export const MODAL_HOURS = 'HOURS_MODAL'
export const MODAL_LIST_ADD_USER = 'LIST_ADD_USER'
export const MODAL_LIST_CREATE = 'LIST_CREATE'
export const MODAL_LIST_DELETE = 'LIST_DELETE'
export const MODAL_LIST_EDITOR = 'LIST_EDITOR'
export const MODAL_LIST_MEMBERS = 'LIST_MEMBERS'
export const MODAL_LIST_SUBSCRIBERS = 'LIST_SUBSCRIBERS'
export const MODAL_LOCATION = 'MODAL_LOCATION'
export const MODAL_MARKETPLACE_LISTING_FILTER = 'MARKETPLACE_LISTING_FILTER'
export const MODAL_MEDIA = 'MEDIA'
export const MODAL_MUTE = 'MUTE'
export const MODAL_PRO_UPGRADE = 'PRO_UPGRADE'
export const MODAL_REPORT = 'REPORT'
export const MODAL_STATUS = 'MODAL_STATUS'
export const MODAL_STATUS_LIKES = 'STATUS_LIKES'
export const MODAL_STATUS_REPOSTS = 'STATUS_REPOSTS'
export const MODAL_STATUS_QUOTES = 'STATUS_QUOTES'
export const MODAL_STATUS_REVISIONS = 'STATUS_REVISIONS'
export const MODAL_TOP_FRIENDS_VIEW = 'TOP_FRIENDS_VIEW'
export const MODAL_TOP_FRIENDS_EDIT = 'TOP_FRIENDS_EDIT'
export const MODAL_UNAUTHORIZED = 'UNAUTHORIZED'
export const MODAL_UNFOLLOW = 'UNFOLLOW'
export const MODAL_VIDEO = 'VIDEO'
export const MODAL_REMOVE_REPLY = 'REMOVE_REPLY'
export const MODAL_AD = 'AD'

export const COMMENT_SORTING_TYPE_NEWEST = 'newest'
export const COMMENT_SORTING_TYPE_OLDEST = 'oldest'
export const COMMENT_SORTING_TYPE_TOP = 'most-liked'

export const GROUP_LIST_SORTING_TYPE_ALPHABETICAL = 'abc'
export const GROUP_LIST_SORTING_TYPE_MOST_POPULAR = 'member-desc'
export const GROUP_LIST_SORTING_TYPE_JOINED = 'joined'

export const LISTS_SORTING_TYPE_ALPHABETICAL = 'abc'
export const LISTS_SORTING_TYPE_SUBS_DESC = 'subs-desc'

// from server
export const PREVIEW_CARD_GAB_CONTENT_TYPE_GROUP = 1
export const PREVIEW_CARD_GAB_CONTENT_TYPE_FEED = 2
export const PREVIEW_CARD_GAB_CONTENT_TYPE_MARKETPLACE_LISTING = 3

// from server
export const SUGGESTION_TYPE_VERIFIED = 'verified'
export const SUGGESTION_TYPE_RELATED = 'related'
export const SUGGESTION_TYPE_GROUPS = 'groups'
export const SUGGESTION_TYPE_FEEDS = 'feeds'
export const SUGGESTION_TYPE_TAGS = 'tags'
export const SUGGESTION_TYPES = [
  SUGGESTION_TYPE_VERIFIED,
  SUGGESTION_TYPE_RELATED,
  SUGGESTION_TYPE_GROUPS,
  SUGGESTION_TYPE_FEEDS,
  SUGGESTION_TYPE_TAGS,
]

export const LIST_TYPE_FEATURED = 'featured'
export const LIST_TYPE_MEMBER_OF = 'member_of'
export const LIST_TYPE_SUBSCRIBED_TO = 'subscribed_to'
export const LIST_TYPE_OWN = 'own'

export const FONT_SIZES_EXTRA_SMALL = '12px'
export const FONT_SIZES_SMALL = '13px'
export const FONT_SIZES_NORMAL = '14px'
export const FONT_SIZES_MEDIUM = '15px'
export const FONT_SIZES_LARGE = '16px'
export const FONT_SIZES_EXTRA_LARGE = '17px'

export const FONT_SIZES = {
  'extra-small': '12px',
  small: '13px',
  normal: '14px',
  medium: '15px',
  large: '16px',
  'extra-large': '17px'
}

export const THEMES = ['white', 'light', 'muted', 'night', 'black']

export const DEFAULT_THEME = 'black'
export const DEFAULT_FONT_SIZE = 'normal'

export const SHORTCUT_TYPE_TRENDS_RSS = 'trends_rss'
export const SHORTCUT_TYPE_BUSINESS = 'business'

export const NOTIFICATION_FILTERS = [
  'all',
  'mention',
  'favourite',
  'quote',
  'reblog',
  'follow',
  'follow_requests'
]

export const GAB_COM_INTRODUCE_YOURSELF_GROUP_ID = '12'

export const MIN_ACCOUNT_CREATED_AT_ONBOARDING = 1594789200000 // 2020-07-15

export const EXPIRATION_OPTION_5_MINUTES = 'five_minutes'
export const EXPIRATION_OPTION_1_HOUR = 'one_hour'
export const EXPIRATION_OPTION_6_HOURS = 'six_hours'
export const EXPIRATION_OPTION_1_DAY = 'one_day'
export const EXPIRATION_OPTION_3_DAYS = 'three_days'
export const EXPIRATION_OPTION_7_DAYS = 'one_week'

export const EXPIRATION_OPTION_NAMES = {
  [EXPIRATION_OPTION_5_MINUTES]: '5m',
  [EXPIRATION_OPTION_1_HOUR]: '1h',
  [EXPIRATION_OPTION_6_HOURS]: '6h',
  [EXPIRATION_OPTION_1_DAY]: '1d',
  [EXPIRATION_OPTION_3_DAYS]: '3d',
  [EXPIRATION_OPTION_7_DAYS]: '7d'
}

export const LOCAL_STORAGE_BLOCKS = 'blocks'
export const LOCAL_STORAGE_MUTES = 'mutes'
export const LOCAL_STORAGE_BLOCKED_BY = 'blockedby'
export const LOCAL_STORAGE_GROUP_BLOCKS = 'group_blocks'

/**
 * On timelines how many queue items should we load before stopping the queue
 * timer?
 */
export const TIMELINES_MAX_QUEUE_ITEMS = 10

export const HOME_TIMELINE_SORTING_TYPE_NEWEST = 'newest'
export const HOME_TIMELINE_SORTING_TYPE_NO_REPOSTS = 'no-reposts'
export const HOME_TIMELINE_SORTING_TYPE_WITH_GROUPS = 'with-groups'
export const HOME_TIMELINE_SORTING_TYPE_TOP = 'top'
export const HOME_TIMELINE_SORTING_TYPE_HOT = 'hot'

export const HOME_SORTS = Object.freeze([
  {
    key: HOME_TIMELINE_SORTING_TYPE_NEWEST,
    title: "Newest",
    subtitle: "See all posts, reposts in chronological order",
    queue: true,
    isDefault: false
  },
  {
    key: HOME_TIMELINE_SORTING_TYPE_WITH_GROUPS,
    title: "Newest, with group posts",
    subtitle: "Include posts from your groups in the timeline, with no reposts.",
    queue: true,
    isDefault: true
  },
  {
    key: HOME_TIMELINE_SORTING_TYPE_NO_REPOSTS,
    title: "Newest, no reposts",
    subtitle: "See all posts in chronological order",
    queue: true,
    isProOnly: true,
  },
  {
    key: HOME_TIMELINE_SORTING_TYPE_HOT,
    title: "Hot posts",
    subtitle: "See the most popular and recent gabs from people you follow",
  },
  {
    key: HOME_TIMELINE_SORTING_TYPE_TOP,
    title: "Top posts from 24 hours",
    subtitle: "See all posts sorted by most liked, commented and reposted",
  }
])

export const PRO_POLLS_TIMELINE_SORTING_TYPE_MOST_VOTES = 'most_votes'

export const GROUP_TIMELINE_SORTING_TYPE_HOT = 'hot'
export const GROUP_TIMELINE_SORTING_TYPE_NEWEST = 'newest'
export const GROUP_TIMELINE_SORTING_TYPE_RECENT_ACTIVITY = 'recent'
export const GROUP_TIMELINE_SORTING_TYPE_TOP = 'top'

export const TIMELINE_SORTING_TYPE_RISING = 'rising'

export const ACCEPTED_GROUP_TABS = ['new', 'featured', 'member', 'admin']

export const GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_TODAY = 'today'
export const GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_WEEKLY = 'weekly'
export const GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_MONTHLY = 'monthly'
export const GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_YEARLY = 'yearly'
export const GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_ALL_TIME = 'all_time'

export const GROUP_SORT_MESSAGES = {
  hotTitle: "Hot Posts",
  hotSubtitle: "See the most popular and recent gabs",
  topTitle: "Top Posts",
  topSubtitle: "See gabs with most comments, likes and reposts first",
  topTodayTitle: "Today",
  topWeekTitle: "This Week",
  topMonthTitle: "This Month",
  topYearTitle: "This Year",
  topAllTitle: "All Time",
  recentTitle: "Recent Activity",
  recentSubtitle: "See gabs with most recent comments first",
  newTitle: "New Posts",
  newSubtitle: "See most recent gabs first",
  risingTitle: "Rising Posts",
  risingSubtitle: "See new gabs that are rising in popularity",
}

// ⚠️ GROUP_SORTS and EXPLORE_SORTS are sharing titles and subtitles. If they need
// to change please make a copy of the labels for explore.
export const GROUP_SORTS = Object.freeze([
  {
    key: GROUP_TIMELINE_SORTING_TYPE_HOT,
    title: GROUP_SORT_MESSAGES.hotTitle,
    subtitle: GROUP_SORT_MESSAGES.hotSubtitle
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_NEWEST,
    title: GROUP_SORT_MESSAGES.newTitle,
    subtitle: GROUP_SORT_MESSAGES.newSubtitle,
    isDefault: true,
    hideForFeatured: true,
    queue: true
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_RECENT_ACTIVITY,
    title: GROUP_SORT_MESSAGES.recentTitle,
    subtitle: GROUP_SORT_MESSAGES.recentSubtitle,
    hideForFeatured: true
  },
  {
    key: TIMELINE_SORTING_TYPE_RISING,
    title: GROUP_SORT_MESSAGES.risingTitle,
    subtitle: GROUP_SORT_MESSAGES.risingSubtitle,
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP,
    title: GROUP_SORT_MESSAGES.topTitle,
    subtitle: GROUP_SORT_MESSAGES.topSubtitle,
    usesTopSorts: true
  }
])

export const VIDEO_SORTS = Object.freeze([
  {
    key: GROUP_TIMELINE_SORTING_TYPE_NEWEST,
    title: GROUP_SORT_MESSAGES.newTitle,
    subtitle: GROUP_SORT_MESSAGES.newSubtitle,
    isDefault: true,
    hideForFeatured: true,
    queue: true,
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP,
    title: GROUP_SORT_MESSAGES.topTitle,
    subtitle: GROUP_SORT_MESSAGES.topSubtitle,
    usesTopSorts: true,
  }
])

export const GROUP_SORT_TOPS = Object.freeze([
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_TODAY,
    title: GROUP_SORT_MESSAGES.topTodayTitle,
    isDefault: true
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_WEEKLY,
    title: GROUP_SORT_MESSAGES.topWeekTitle
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_MONTHLY,
    title: GROUP_SORT_MESSAGES.topMonthTitle
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_YEARLY,
    title: GROUP_SORT_MESSAGES.topYearTitle
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_ALL_TIME,
    title: GROUP_SORT_MESSAGES.topAllTitle
  }
])

// ⚠️ GROUP_SORTS and EXPLORE_SORTS are sharing titles and subtitles. If they need
// to change please make a copy of the labels for explore.
export const EXPLORE_SORTS = Object.freeze([
  {
    key: GROUP_TIMELINE_SORTING_TYPE_HOT,
    title: GROUP_SORT_MESSAGES.hotTitle,
    subtitle: GROUP_SORT_MESSAGES.hotSubtitle,
    isDefault: true
  },
  {
    key: TIMELINE_SORTING_TYPE_RISING,
    title: GROUP_SORT_MESSAGES.risingTitle,
    subtitle: GROUP_SORT_MESSAGES.risingSubtitle,
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP,
    title: GROUP_SORT_MESSAGES.topTitle,
    subtitle: GROUP_SORT_MESSAGES.topSubtitle,
    usesTopSorts: true
  }
])

export const EXPLORE_SORT_TOPS = Object.freeze([
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_TODAY,
    title: GROUP_SORT_MESSAGES.topTodayTitle,
    isDefault: true
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_WEEKLY,
    title: GROUP_SORT_MESSAGES.topWeekTitle
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_MONTHLY,
    title: GROUP_SORT_MESSAGES.topMonthTitle
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_YEARLY,
    title: GROUP_SORT_MESSAGES.topYearTitle
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP_OPTION_ALL_TIME,
    title: GROUP_SORT_MESSAGES.topAllTitle
  }
])

// all group sort except "hot"
export const ACCOUNT_TIMELINE_SORTS = [
  {
    key: GROUP_TIMELINE_SORTING_TYPE_NEWEST,
    title: GROUP_SORT_MESSAGES.newTitle,
    subtitle: GROUP_SORT_MESSAGES.newSubtitle,
    isDefault: true,
    hideForFeatured: true,
    queue: true,
  },
  {
    key: HOME_TIMELINE_SORTING_TYPE_NO_REPOSTS,
    title: "Newest, no reposts",
    subtitle: "See all posts in chronological order",
    queue: true,
    isProOnly: true,
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP,
    title: GROUP_SORT_MESSAGES.topTitle,
    subtitle: GROUP_SORT_MESSAGES.topSubtitle,
    usesTopSorts: true,
    isProOnly: true,
  }
]

// all group sort plus "mote votes"
export const PRO_POLLS_TIMELINE_SORTS = [
  ...GROUP_SORTS,
  {
    key: PRO_POLLS_TIMELINE_SORTING_TYPE_MOST_VOTES,
    title: "Most Votes",
    subtitle: "See polls with most votes first",
  },
]

// all groups but hot is default
export const PRO_TIMELINE_SORTS = [
  {
    key: GROUP_TIMELINE_SORTING_TYPE_HOT,
    title: GROUP_SORT_MESSAGES.hotTitle,
    subtitle: GROUP_SORT_MESSAGES.hotSubtitle,
    isDefault: true,
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_NEWEST,
    title: GROUP_SORT_MESSAGES.newTitle,
    subtitle: GROUP_SORT_MESSAGES.newSubtitle,
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_RECENT_ACTIVITY,
    title: GROUP_SORT_MESSAGES.recentTitle,
    subtitle: GROUP_SORT_MESSAGES.recentSubtitle,
    hideForFeatured: true,
  },
  {
    key: GROUP_TIMELINE_SORTING_TYPE_TOP,
    title: GROUP_SORT_MESSAGES.topTitle,
    subtitle: GROUP_SORT_MESSAGES.topSubtitle,
    usesTopSorts: true,
  }
]

export const EXPLORE_SORT_CREATE_PARAMS = ({ sortByValue, sortByTopValue }) => {
  if ([GROUP_TIMELINE_SORTING_TYPE_TOP, PRO_POLLS_TIMELINE_SORTING_TYPE_MOST_VOTES].indexOf(sortByValue) > -1) {
    // see app/controllers/api/v2/timelines/explore_controller.rb
    return { sort_by: `${sortByValue}_${sortByTopValue}` }
  }
  return { sort_by: sortByValue }
}

export const TOAST_TYPE_ERROR = 'error'
export const TOAST_TYPE_SUCCESS = 'success'

// from server
export const SEARCH_TAB_TOP = 'top'
export const SEARCH_TAB_ACCOUNT = 'account'
export const SEARCH_TAB_STATUS = 'status'
export const SEARCH_TAB_GROUP = 'group'
export const SEARCH_TAB_LINK = 'link'
export const SEARCH_TAB_FEED = 'feed'
export const SEARCH_TAB_HASHTAG = 'hashtag'
export const SEARCH_TAB_MARKETPLACE = 'marketplace'
export const SEARCH_TAB_BUSINESS = 'business'

export const SEARCH_TABS = [
  {
    title: 'Top',
    to: '/search/top',
    tab: SEARCH_TAB_TOP,
  },
  {
    title: 'People',
    to: '/search/people',
    tab: SEARCH_TAB_ACCOUNT
  },
  {
    title: 'Groups',
    to: '/search/groups',
    tab: SEARCH_TAB_GROUP
  },
  {
    title: 'Statuses',
    to: '/search/statuses',
    tab: SEARCH_TAB_STATUS
  },
  {
    title: 'Links',
    to: '/search/links',
    tab: SEARCH_TAB_LINK
  },
  {
    title: 'Feeds',
    to: '/search/feeds',
    tab: SEARCH_TAB_FEED
  },
  {
    title: 'Businesses',
    to: '/search/businesses',
    tab: SEARCH_TAB_BUSINESS,
  },
  {
    // go to page with marketplace listing search with query. then it automatically searches
    title: 'Marketplace',
    to: '/search/marketplace',
    // qsName: 'query',
    tab: SEARCH_TAB_MARKETPLACE
  },
].filter(Boolean)

export const TIMELINE_INJECTION_DONATE = 'TI_DONATE'
export const TIMELINE_INJECTION_FEATURED_GROUPS = 'TI_FEATURED_GROUPS'
export const TIMELINE_INJECTION_GROUP_CATEGORIES = 'TI_GROUP_CATEGORIES'
export const TIMELINE_INJECTION_PROGRESS = 'TI_PROGRESS'
export const TIMELINE_INJECTION_PRO_UPGRADE = 'TI_PRO_UPGRADE'
export const TIMELINE_INJECTION_INVEST_NOW = 'TI_INVEST_NOW'
// export const TIMELINE_INJECTION_PWA = 'TI_PWA'
export const TIMELINE_INJECTION_SHOP = 'TI_SHOP'
export const TIMELINE_INJECTION_USER_SUGGESTIONS = 'TI_USER_SUGGESTIONS'
export const TIMELINE_PROMOTED_BUSINESSES = 'TI_PROMOTED_BUSINESSES'
export const TIMELINE_PROMOTED_BUSINESS_LISTINGS = 'TI_PROMOTED_BUSINESS_LISTINGS'

export const TIMELINE_INJECTION_WEIGHT_DEFAULT = 1
export const TIMELINE_INJECTION_WEIGHT_MULTIPLIER = 100
export const TIMELINE_INJECTION_WEIGHT_SUBTRACTOR = 0.005
export const TIMELINE_INJECTION_WEIGHT_MIN = 0.01

export const GAB_DECK_MAX_ITEMS = 8
export const GAB_DECK_OPTIONS = [
  'home',
  'user.id',
  'notifications',
  'list.id',
  'likes',
  'bookmarks',
  'pro',
  'compose',
  'group.id',
  'explore',
  'news.id',
  'hashtag.id'
]

export const GAB_AD_PLACEMENTS = {
  status: 'status',
  banner: 'banner',
  panel: 'panel',
  buyout: 'buyout'
}

export const TIMELINE_SCROLL_KEYS_EXCLUDED_FROM_ADS = [
  //'account_timeline',
  'liked_statuses',
  'account_comments_timeline'
]

export const MARKETPLACE_LISTING_VIEW_TAB_TYPE_CARD = 'card'
export const MARKETPLACE_LISTING_VIEW_TAB_TYPE_LIST = 'list'

export const NEWS_VIEW_TAB_TYPE_CARD = 'card'
export const NEWS_VIEW_TAB_TYPE_LIST = 'list'

export const MARKETPLACE_LISTING_SORY_BY = {
  newest: 'Newest',
  oldest: 'Oldest',
  'price-asc': 'Price Asc',
  'price-desc': 'Price Desc'
}

export const MARKETPLACE_LISTING_COLOR_OPTIONS = [
  { title: '', value: '' },
  { title: "Black", value: "black" },
  { title: "Blue", value: "blue" },
  { title: "Brown", value: "brown" },
  { title: "Gold", value: "gold" },
  { title: "Green", value: "green" },
  { title: "Gray", value: "gray" },
  { title: "Pink", value: "pink" },
  { title: "Purple", value: "purple" },
  { title: "Red", value: "red" },
  { title: "Silver", value: "silver" },
  { title: "Orange", value: "orange" },
  { title: "White", value: "white" },
  { title: "Yellow", value: "yellow" },
  { title: "Charcoal", value: "charcoal" },
  { title: "Off white", value: "off-white" },
  { title: "Tan", value: "tan" },
  { title: "Beige", value: "beige" },
  { title: "Burgundy", value: "burgundy" },
  { title: "Turquoise", value: "turquoise" }
]

const year_options = [{ title: '', value: '' }];
for (let year = 1900; year <= 2024; year++) {
  year_options.push({
    title: `${year}`,
    value: `${year}`,
  })
}
export const MARKETPLACE_LISTING_YEAR_OPTIONS = year_options

// from server
export const MARKETPLACE_LISTING_STATUS_PENDING_REVIEW = 0
export const MARKETPLACE_LISTING_STATUS_PENDING_CHANGES = 1
export const MARKETPLACE_LISTING_STATUS_REJECTED = 2
export const MARKETPLACE_LISTING_STATUS_APPROVED = 3
export const MARKETPLACE_LISTING_STATUS_RUNNING = 4
export const MARKETPLACE_LISTING_STATUS_EXPIRED = 5
export const MARKETPLACE_LISTING_STATUS_SOLD = 6
export const MARKETPLACE_LISTING_STATUS_ARCHIVED = 7
export const MARKETPLACE_LISTING_STATUS_PAUSED = 8

// from server
export const BUSINESS_PROMOTION_EXPLORE_PAGE_BUSINESS = 1
export const BUSINESS_PROMOTION_EXPLORE_PAGE_BUSINESS_MARKETPLACE_LISTINGS = 2
export const BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_FRONT_PAGE = 100
export const BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_CATEGORY_PAGE = 101
export const BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_INJECTION = 102
export const BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_PANEL = 103
export const BUSINESS_PROMOTION_BUSINESSES_FRONT_PAGE = 200
export const BUSINESS_PROMOTION_BUSINESSES_CATEGORY_PAGE = 201
export const BUSINESS_PROMOTION_BUSINESSES_INJECTION = 202
export const BUSINESS_PROMOTION_BUSINESSES_PANEL = 203
export const BUSINESS_PROMOTION_ADS = 300

export const BUSINESS_PROMOTION_LISTINGS = [
  BUSINESS_PROMOTION_EXPLORE_PAGE_BUSINESS_MARKETPLACE_LISTINGS,
  BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_FRONT_PAGE,
  BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_CATEGORY_PAGE,
  BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_INJECTION,
  BUSINESS_PROMOTION_MARKETPLACE_LISTINGS_PANEL,
]

// from server
export const MARKETPLACE_LISTING_AVAILABLE_UNIQUE_ATTRIBUTES =  [
  "gender",
  "age",
  "type",
  "is_handmade",
  "author",
  "isbn",
  "age_group",
  "grade_level",
  "position_title",
  "position_type",
  "pay_structure",
  "is_remote",
  "responsibilities",
  "sector",
  "bedrooms",
  "bathrooms",
  "sale_type",
  "sq_ft",
  "place_type",
  "lot_size",
  "age_range",
  "year",
  "make",
  "model",
  "mileage",
  "ext_color",
  "int_color",
  "body_style",
  "fuel_type",
  "transmission",
  "clean_title",
  "brand",
  "color",
]

// from server
export const MAX_MARKETPLACE_IMAGE_UPLOAD = 8

// from server
export const MARKETPLACE_LISTING_CONDITIONS = [
  {
    title: 'All',
    value: null
  },
  {
    title: 'New',
    value: 0
  },
  {
    title: 'Renewed',
    value: 1
  },
  {
    title: 'Used - Like new',
    value: 2
  },
  {
    title: 'Used - Very good',
    value: 3
  },
  {
    title: 'Used - Good',
    value: 4
  },
  {
    title: 'Used - Acceptable',
    value: 5
  }
]

/**
 * When making a comment/reply it will prefill the box with a username. We can
 * ignore that. If they didn't type anything else it's considered blank below.
 * @type {RegExp}
 */
export const leadingAtMention = /^@\w+\s?$/

export const COMPOSE_MAX_MEDIA_ATTACHMENTS_LIMIT = 8

export const ACCOUNT_IS_PARODY_DESCRIPTION = "A parody account depicts another person, group, or organization in their profile to discuss, satirize, or share information about that entity."
